import React from "react";
import dayjs from "dayjs";

import {
    Dialog,
    DialogContent,
    Box,
    Button,
    Typography
} from "@mui/material";
import { useUtilityContext } from "../../utility-provider";
import { LOCAL_CONSTANT } from "../Const";
import MessageDialog from "../components/MessageDialog";
import { uploadFile, uploadMiddleProduct1File } from "../../utility/storage";
import { postPython } from "../../api/ApiCall";
import { useUserContext } from "../../user-provider";
import { apiRequest } from "../../api/ApiCall";


export interface messageDialogProps {
    props: {
        open: boolean,
        handleModal: any,
    }
}

const GisImportModal: React.FC<messageDialogProps> = ({ props }) => {
    const [open, setOpen] = React.useState(false);

    const utilityCtx = useUtilityContext();

    const [message, setMessage] = React.useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] = React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);
    const [modalMode, setModalMode] = React.useState<string>("menu");
    const [uploadMode, setUploadMode] = React.useState<string>("");
    // アップロードする中間生成物1のファイル
    const [middleProduct1Files, setMiddleProduct1Files] = React.useState<any>([]);
    // アップロードした中間生成物1のファイル数をカウント
    const [uploadedsMiddleProduct1Count, setUploadedsMiddleProduct1Count] = React.useState<number>(0);
    // アップロードする中間生成物1のファイル数の合計
    const [totalsMiddleProduct1Files, setTotalsMiddleProduct1Files] = React.useState<number>(0);
    // アップロード中の中間生成物のモーダル
    const [uploadOpenMiddleProduct1, setUploadOpenMiddleProduct1] = React.useState<boolean>(false);
    // アップロード中の中間生成物のモーダル画面切替
    const [middleProduct1ModalMode, setMiddleProduct1ModalMode] = React.useState<string>("");

    const [userType, setUserType] = React.useState("");
    const user = useUserContext();

    React.useEffect(() => {
        if (props.open) {
            setOpen(props.open);
        }
    }, [props.open])


    const handleClose = () => {
        setOpen(false)
        setModalMode("menu")
        props.handleModal()
    }

    const handleChangeFile = (newFile: any) => {
        switch (uploadMode) {
            // 中間生成物1の場合は複数ファイルをアップロード
            case "middleProduct1":
                setModalMode("middleProduct1Upload");
                setUploadedsMiddleProduct1Count(0);                         //アップロードした中間生成物1のファイル数をカウントを初期化
                setTotalsMiddleProduct1Files(newFile.target.files.length);
                const fileArray = Array.from(newFile.target.files);         // FileListを配列に変換
                setMiddleProduct1Files(fileArray);                          // useStateに保存 
                setUploadOpenMiddleProduct1(true);                          // アップロード中の中間生成物のモーダルを開く
                setMiddleProduct1ModalMode("middleProduct1Upload");         // 「ファイル取り込み処理 登録中」のモーダル画面に切替
                break;
            // 中間生成物1以外は単一ファイルをアップロード
            default:
                fileUpload(newFile.target.files[0]);
                break;
        }
        // ファイル入力をリセット
        newFile.target.value = "";
    };

    const handleClickFile = (uploadModeKey: string) => {
        switch (uploadModeKey) {
            case "middleProduct1":
                setUploadMode(uploadModeKey);
                const fileElemMiddleProduct1  = document.getElementById("gis-upload-middle-product1");
                if (fileElemMiddleProduct1) {
                    fileElemMiddleProduct1.click();
                }
                break;   
            default:
                setUploadMode(uploadModeKey);
                const fileElem = document.getElementById("gis-upload");
                if (fileElem) {
                    fileElem.click();
                }
                break;
        }
    }

    const closeMessageDialog = () => {
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    const fileUpload = (file: any) => {
        const params = setParams(file.name);

        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                handleClose();
                setMessage(setModeMessage("start"))
                setMessageDialogOpen(true)
                await uploadFile(file, "temp/" + params["query"]["file_name"])
                const response = await postPython(params)
                if (params["endPoint"] === "/n152db") {
                    if (response.data.data.status) {
                        setMessage(setModeMessage("success"))
                    } else {
                        setMessage(setModeMessage("error"))
                    }
                } else {
                    setMessage(setModeMessage("success"))
                }
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(setModeMessage("error"))
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    // 中間生成物1をアップロード
    const middleProduct1fileUpload = async (file: any) => {
        try {
            handleClose();
            // パラメータを設定
            const params = await setMiddleParams(file.name);
            // ファイルをアップロード（ログ付き）
            await uploadMiddleProduct1File(file, "temp/" + params["query"]["file_name"], user);
            // アップロード済みのファイル数を更新
            setUploadedsMiddleProduct1Count(prevCount => prevCount + 1);
            // ファイルパスをオブジェクトとして配列に追加
            return {
                upload_file_path: params["query"]["file_name"],
                upload_staff_number: params["query"]["user_data"]["update_staff_number"]
            };
        } catch (e) {
            console.log(e);
            setMessageDialogOpen(true);
            setMessage(setModeMessage("error"));
            setHasButton(true);
        }
        return;
    };

    const setMiddleParams = async (fileName: string) => {
        let params = {
            mode: "regist",
            endPoint: "",
            query: {
                file_name: fileName,
                user_data: {
                    update_top_department: "",
                    update_department: "",
                    update_job: "",
                    update_mail: "",
                    update_staff_number: "",
                    update_name: ""
                }
            }
        };
        const userData = JSON.parse(user.userData);
        switch (uploadMode) {
            case "middleProduct1":
                params["query"] = {
                    file_name: dayjs().format("YYYYMMDDHHmmss") + "_" + fileName,
                    user_data: {
                        update_top_department: userData.top_department_code_OA,
                        update_department: userData.department_code_OA,
                        update_job: userData.job_category_code_OA,
                        update_mail: userData.email.toString(),
                        update_staff_number: userData.staff_number,
                        update_name: userData.user_name
                    }
                }
                params["endPoint"] = "/excel2db-middle-product"
                break;
        }
        return params;
    }

    const setParams = (fileName: string) => {
        let params = {
            mode: "regist",
            endPoint: "",
            query: {
                file_name: fileName,
                user_data: {}
            }
        };
        switch (uploadMode) {
            case "5minute":
                params["endPoint"] = "/shp2db"
                break;
            case "n15AdditionalTradeArea":
                params["endPoint"] = "/n152db"
                break;
        }
        return params;
    }

    const setModeMessage = (processKey: string) => {
        let messageVal = ""
        switch (uploadMode) {
            case "5minute":
                if (processKey === "start") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_5MINUTE_WALK_TRADE_AREA
                } else if (processKey === "success") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_5MINUTE_WALK_TRADE_AREA
                } else if (processKey === "error") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_5MINUTE_WALK_TRADE_AREA
                }
                break;
            case "middleProduct1":
                if (processKey === "start") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD
                } else if (processKey === "success") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_UPLOAD
                } else if (processKey === "error") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROE_UPLOAD
                }
                break;
            case "n15AdditionalTradeArea":
                if (processKey === "start") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_N15_TRADE_AREA
                } else if (processKey === "success") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_N15_WALK_TRADE_AREA
                } else if (processKey === "error") {
                    messageVal = LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_N15_WALK_TRADE_AREA
                }
                break;
        }

        return messageVal
    }

    const handleIntermediateProducts = (key: string) => {
        setModalMode(key)
    }

    // 中間生成物1のファイルが存在する場合、アップロードを開始
    React.useEffect(() => {
        if (middleProduct1Files.length > 0) {
            (async () => {
                const uploadFiles = [];
                try {
                    for (let i = 0; i < middleProduct1Files.length; i++) {
                        const uploadFile = await middleProduct1fileUpload(middleProduct1Files[i]);
                        if (
                            uploadFile &&
                            uploadFile.upload_file_path &&
                            uploadFile.upload_staff_number
                        ) {
                            uploadFiles.push(uploadFile);
                        }
                    }
                    // 「ファイル取り込み処理 登録中」のモーダル画面に切替
                    setMiddleProduct1ModalMode("middleProduct1Regist"); 
                    if (uploadFiles.length > 0) {
                        const postMiddleParams = {
                            mode: "regist",
                            endPoint: "/location/Middle/v1/file-regist",
                            query: {
                                file_import: uploadFiles
                            }
                        }
                        await apiRequest(postMiddleParams);
                    }
                    // 「ファイル取り込み処理 登録完了しました」のモーダル画面に切替
                    setMiddleProduct1ModalMode("middleProduct1Complete");
                } catch (e) {
                    console.log(e);
                    setUploadOpenMiddleProduct1(false);
                    setMessageDialogOpen(true);
                    setMessage(setModeMessage("error"));
                    setHasButton(true);
                }
            })(); // 即時実行
        }
    }, [middleProduct1Files]);

    //ユーザー取得
    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    return (
        <>
            <Dialog
                open={open}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                onClose={handleClose}
            >
                <DialogContent>
                    {
                        modalMode === "menu" &&
                        <Box sx={{ margin: "20px 40px" }}>
                            <Box sx={{ textAlign: "center", margin: "20px 10px" }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    sx={{ padding: "10px 20px" }}
                                    onClick={(e) => { handleClickFile("middleProduct1") }}
                                >{LOCAL_CONSTANT.LABEL.INTERMEDIATE_PRODUCTS}1</Button>
                            </Box>
                            <Box sx={{ textAlign: "center", margin: "20px 10px" }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    sx={{ padding: "10px 20px" }}
                                    onClick={(e) => { handleIntermediateProducts("second") }}
                                >{LOCAL_CONSTANT.LABEL.INTERMEDIATE_PRODUCTS}2</Button>
                            </Box>
                            <Box sx={{ textAlign: "center", margin: "20px 10px" }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    sx={{ padding: "10px 20px" }}
                                    onClick={(e) => { handleClickFile("5minute") }}
                                >{LOCAL_CONSTANT.LABEL.FIVE_MINUTE_WALK_TRADE_AREA}</Button>
                            </Box>
                        </Box>
                    }
                    {
                        modalMode === "second" &&
                        <Box>
                            <Box sx={{ margin: "20px 40px" }}>
                                <Box sx={{ textAlign: "center", margin: "20px 10px" }}>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        sx={{ padding: "10px 20px" }}
                                        onClick={(e) => { handleClickFile("n15AdditionalTradeArea") }}
                                    >{LOCAL_CONSTANT.LABEL.N15_ADDITIONAL_TRADE_AREA}</Button>
                                </Box>
                            </Box>
                        </Box>
                    }
                </DialogContent>
                <input
                    id="gis-upload-middle-product1"
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    onChange={handleChangeFile}
                />
                <input
                    id="gis-upload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleChangeFile}
                />
                <MessageDialog props={{
                    open: messageDialogOpen,
                    handleModal: closeMessageDialog,
                    body: message,
                    hasButton: hasButton,
                    buttonBody: LOCAL_CONSTANT.LABEL.CLOSE
                }} />
            </Dialog>
            <Dialog
                open={uploadOpenMiddleProduct1}
                aria-describedby="middle-product1-upload-dialog-description"
            >
                <DialogContent>
                    {middleProduct1ModalMode === "middleProduct1Upload" &&
                        <Box>
                            <Typography>{totalsMiddleProduct1Files}件中 {uploadedsMiddleProduct1Count}件アップロード済</Typography>
                            <Typography sx={{ mt: 2, color: "red" }}>
                                ※画面更新を行わないで下さい
                            </Typography>
                        </Box>
                    }
                    {middleProduct1ModalMode === "middleProduct1Regist" &&
                        <Box>
                            <Typography>ファイル取り込み処理 登録中</Typography>
                            <Typography sx={{ mt: 2, color: "red" }}>
                                ※画面更新を行わないで下さい
                            </Typography>
                        </Box>
                    }
                    {middleProduct1ModalMode === "middleProduct1Complete" &&
                        <Box>
                            <Typography>ファイル取り込み処理 登録完了しました</Typography>
                            <Box sx={{ mt: 2, textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    onClick={ () => {setUploadOpenMiddleProduct1(false)} }
                                >閉じる</Button>
                            </Box>
                        </Box>
                    }
                </DialogContent>
            </Dialog>
        </>
    );
}

export default GisImportModal;
